
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20 7H2V10H20V7ZM11 16C11 16.3425 11.0344 16.6769 11.1 17H2V14H11.416C11.1484 14.6125 11 15.2889 11 16Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M15 14.8034C15 13.9934 16.56 13.6034 18 13.6034C19.44 13.6034 21 13.9934 21 14.8034C21 15.6134 19.44 16.0034 18 16.0034C16.56 16.0034 15 15.6134 15 14.8034ZM18 16.6034C16.86 16.6034 15.69 16.3934 15 15.8834V17.2034C15 18.0134 16.56 18.4034 18 18.4034C19.44 18.4034 21 18.0134 21 17.2034V15.8834C20.31 16.3934 19.14 16.6034 18 16.6034ZM18 19.0034C16.86 19.0034 15.69 18.7934 15 18.2834V19.6034C15 20.4134 16.56 20.8034 18 20.8034C19.44 20.8034 21 20.4134 21 19.6034V18.2834C20.31 18.7934 19.14 19.0034 18 19.0034Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowAssignmentDataFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
